import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { TixVenuesService } from '@tix/venues/state';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VenueIdResolver implements Resolve<any> {
  constructor(
    private venuesService: TixVenuesService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<string | null> {
    const venueId = route.paramMap.get('id');
    if (!venueId) return of(null);
    return of(venueId);
  }
}
